/**
 * @flow
 * @author: Pavan
 */

import React, { Component } from 'react'
import queryString from 'query-string'
import moment from 'moment'

import BaseDateField from '../../../commons/BaseDateField'
import {
  validatePreferredDate,
  validatePreferredDateAndTime
} from '../../../utils/FormValidations'
import {
  DATE_FORMAT_WITH_TIME,
  UI_FORMAT
} from '../../../constants/DateConstants'

type Props = {
  dateConstants?: Object,
  isMobile: boolean
}

class DateField extends Component<Props> {
  static defaultProps = {
    isMobile: false
  }

  captureDateFieldRef = ref => {
    this.dateFieldInstance = ref
  }
  validate = () =>
    this.dateFieldInstance.validateDateInput(
      this.dateFieldInstance.state.dateValue
    )
  reset = () => {
    this.dateFieldInstance.reset()
  }
  queryParams = { arcades: '' }
  isBhowaniporePresentInQueryParams = () =>
    this.queryParams.arcades === 'bhowanipore'

  isVrCricketBhowaniporePresentInQueryParams = () =>
    this.queryParams.arcades === 'vr-cricket-bhowanipore'

  renderDateLabel = () => {
    const { dateConstants } = this.props
    if (this.isVrCricketBhowaniporePresentInQueryParams()) {
      return 'Preferred Date (optional)'
    } else if (this.isBhowaniporePresentInQueryParams()) {
      return 'Date & Time'
    }
    return dateConstants.dateLabel
  }

  renderDateValidation = () => {
    if (this.isBhowaniporePresentInQueryParams()) {
      return validatePreferredDateAndTime
    }
    return validatePreferredDate
  }

  render() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
    }
    const { dateConstants, isMobile, excludeDates, id } = this.props
    return (
      <BaseDateField
        id={id}
        isMobile={isMobile}
        ref={this.captureDateFieldRef}
        validate={this.renderDateValidation()}
        dateLabel={this.renderDateLabel()}
        placeholderText={
          this.isVrCricketBhowaniporePresentInQueryParams()
            ? 'Preferred Date (optional)'
            : dateConstants.placeholderText
        }
        minDate={moment()}
        showDisabledMonthNavigation
        excludeDates={excludeDates}
        showTimeSelect={this.queryParams.arcades === 'bhowanipore'}
        dateFormat={
          this.queryParams.arcades === 'bhowanipore'
            ? DATE_FORMAT_WITH_TIME
            : UI_FORMAT
        }
        timeIntervals={30}
        validationEnabled={
          this.queryParams.arcades !== 'vr-cricket-bhowanipore'
        }
        minTime={
          this.queryParams.arcades === 'bhowanipore'
            ? moment()
                .hours(10)
                .minutes(0)
            : null
        }
        maxTime={
          this.queryParams.arcades === 'bhowanipore'
            ? moment()
                .hours(22)
                .minutes(0)
            : null
        }
      />
    )
  }
}

export default DateField



// WEBPACK FOOTER //
// ./src/components/FormHomePage/DateField/index.js